import layoutSlice from "../slices/layoutSlice";

export const layoutReducers = {
  layout: layoutSlice,
};
